import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    loadMailingGroups: (context, botId) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.client.url + '/mailinggroup/all/' + botId).then(response => {
            if (response.data.length !== 0) {
                context.commit('loadMailingGroups', response.data)
            } else {
                context.commit('loadMailingGroups', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get keyboards' + error)
        })
    },
    changeCountMailingGroup: (context, payload) => {
        context.commit('changeCountMailingGroup', payload)
    }
}
